import Header from "./components/Header";
import Footer from "./components/Footer";
import GaussianProcessAnimation from './components/GaussianProcess';
import AboutCard from './components/AboutCard';

function App() {
  return (
    <div className="flex flex-col flex-grow w-screen min-h-screen items-center">
      <Header />
      <main className="bg-topography w-screen h-screen flex flex-col items-center justify-center">
        <div className="w-screen h-24" />
        <AboutCard />
        <GaussianProcessAnimation />
      </main>
      <Footer />
    </div>
  );
}

export default App;
